/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function toggleATCText(event, atcElement, originalText, mouseEnterText) {
  /*if ( typeof(atcElement_OriginalInnerText) === 'undefined' ) {
    atcElement_OriginalInnerText = atcElement.innerText;
  };*/
  atcElement.innerText = event.type == 'mouseenter' ? mouseEnterText : originalText ;
}

function toggleATC(event, atcElement, mouseEnterText ) {
  atcElement.style.display = null;

  if (event.type == 'mouseenter') {
    atcElement.disabled = atcElement.disabled ? false : true ;
    atcElement.hidden = atcElement.hidden ? false : true ;
  }

  if (event.type == 'mouseleave') {
    atcElement.disabled = atcElement.disabled ? false : true ;
    atcElement.hidden = atcElement.hidden ? false : true ;
  }

  /*
    if (typeof(enable) === 'undefined') {
      //element.classList.toggle(cssClass);
      // this_toggle();
    } else {
      enable ? this_disable = true : this_disable = false;
    }
  */
}


function pricingModelUpdatePrice(event,priceElement,newPrice) {
  /* priceElementSpan - because the price element is NOT just the actual price data we need to track it's first hidden element */
  priceElementSpan = priceElement.querySelector('.visually-hidden');

  if (event.type == 'mouseenter' ) {
    var current_price = priceElement.innerText.replace(priceElement.querySelector('.visually-hidden').innerText,'').replace('\n','');
    priceElement.dataset.currentPrice = current_price;
    // document.body.classList.add('pricing-option-each--hover');
    // priceElement.innerText = priceElement.innerText.replace(current_price,newPrice);
    priceElement.innerText = newPrice;
    priceElement.prepend(priceElementSpan);
  } else {
    // document.body.classList.remove('pricing-option-each--hover');
    // priceElement.innerText = priceElement.innerText.replace(newPrice,current_price);
    priceElement.innerText = priceElement.dataset.currentPrice;
    priceElement.prepend(priceElementSpan);
  }
}


function standardCaseOnly (atcElement, priceElement, newPrice, variant_title, event) {
  /* skip events from the child <span> of the <label>
  skip when this it's the currently selected option ( label.control.checked )
  if (event.currentTarget !== event.target || event.currentTarget.control.checked == false) {
    return;
  } */

  /*
    2023-11-18 Standard-case-only template
      Please Hide “Price” and “Stock:” from view when Sample variant is moused-over or selected.
      Allow the Price to show when the Each variant is moused-over or selected.
      Hide “Stock:” from view when Each variant is moused-over or selected.
  */

  if (variant_title.toLowerCase().indexOf('case') > -1 ) {
    /* 2024-03-08 future: refactor to new toggleATC & toggleATCText functions */
    atcElement.style.display = null;
    atcElement_OldInnerText = atcElement.innerText;

    atcElement.disabled = atcElement.disabled && event.type == 'mouseenter' ? false : true ;
    atcElement.hidden = atcElement.disabled && event.type == 'mouseenter' ? false : true ;

    atcElement.disabled = atcElement.disabled && event.type == 'mouseleave' ? true : false ;
    atcElement.hidden = atcElement.disabled && event.type == 'mouseleave' ? true : false ;
    // atcElement.innerText = "Sold by the case only.";

    atcElement.innerText = event.type == 'mouseenter' ? "Sold by the case only." : atcElement_OldInnerText ;
  }

  if (variant_title.toLowerCase().indexOf('each') > -1 ) {
    atcElement.hidden = event.type == 'mouseenter'  ? true : false;
    /* 2024-03-08 future: refactor to new pricingModelUpdatePrice function */
    /* priceElementSpan - because the price element is NOT just the actual price data we need to track it's first hidden element */
    priceElementSpan = priceElement.querySelector('.visually-hidden');
    if (event.type == 'mouseenter' ) {
      var current_price = priceElement.innerText.replace(priceElement.querySelector('.visually-hidden').innerText,'').replace('\n','');
      priceElement.dataset.currentPrice = current_price;
      document.body.classList.add('pricing-option-each--hover');
      // priceElement.innerText = priceElement.innerText.replace(current_price,newPrice);
      priceElement.innerText = newPrice;
      priceElement.prepend(priceElementSpan);
    } else {
      document.body.classList.remove('pricing-option-each--hover');
      // priceElement.innerText = priceElement.innerText.replace(newPrice,current_price);
      priceElement.innerText = priceElement.dataset.currentPrice;
      priceElement.prepend(priceElementSpan);
    }
  }

  /* 2024-03-08 future: refactor to new sampleClass function */
  if (variant_title.toLowerCase().indexOf('sample') > -1) {
    atcElement.hidden = event.type == 'mouseenter'  ? true : false;
    if (event.type == 'mouseenter' ) {
      document.body.classList.add('pricing-option-sample--hover');
    } else {
      document.body.classList.remove('pricing-option-sample--hover');
    }

  }
}


function sampleOptionBundleAndCase(atcElement,event) {
  if ( document.body.classList.toString().toLowerCase().indexOf('pricing-option-bundle') != -1 || document.body.classList.toString().toLowerCase().indexOf('pricing-option-case') != -1 ) {
    toggleATCText(event, atcElement, window.languages.productFormAddToCart, window.languages.productFormPricingBundleAndCase);
    toggleATC(event, atcElement);
  }
  toggleClass( document.body, 'pricing-option-sample--hover', (event.type == 'mouseenter') );
}

function eachOptionBundleAndCase(atcElement, priceElement, newPrice, variant_title, event){
  if ( document.body.classList.toString().toLowerCase().indexOf('pricing-option-bundle') != -1 || document.body.classList.toString().toLowerCase().indexOf('pricing-option-case') != -1 ) {
    toggleATCText(event,atcElement, window.languages.productFormAddToCart, window.languages.productFormPricingBundleAndCase);
    toggleATC(event,atcElement);
  }
  toggleClass( document.body, 'pricing-option-each--hover', (event.type == 'mouseenter') );
  pricingModelUpdatePrice(event,priceElement,newPrice);
}

/* 2024-03-08 Paul N., Pricing models - Add templates and logic for bundle-and-case
  Example product - Shrink Band products, "we sell THESE by the "bundle" and by the "case"
    https://aaronpackaging.com/products/77-x-45-clear-flat-cut-pvc-shrink-band?_pos=1&_sid=95785e8ce&_ss=r
  "...please modify a duplicate of the standard-case-only product template for the Shrink Band products.
   I will need it to allow the sale of the BUNDLE as well as by the CASE.
   ~ David C."
*/
function bundleAndCase (atcElement, priceElement, newPrice, variant_title, event) {
  //TODO BUG, select Case-option then hover bundle-option the AtC stays hidden and doesn't come back
  if ( variant_title.toLowerCase().indexOf('bundle') > -1 ) {
    toggleATCText(event,atcElement, window.languages.productFormAddToCart, window.languages.productFormPricingBundleAndCase);
    if ( document.body.classList.toString().toLowerCase().indexOf('pricing-option-case') == -1 ) {
      toggleATC(event,atcElement);
    }
  }
  if (variant_title.toLowerCase().indexOf('case') > -1  ) {
    toggleATCText(event, atcElement, window.languages.productFormAddToCart, window.languages.productFormPricingBundleAndCase);
    if ( document.body.classList.toString().toLowerCase().indexOf('pricing-option-bundle') == -1 ) {
      toggleATC(event, atcElement);
    }
  }

  if (variant_title.toLowerCase().indexOf('each') > -1 ) {
    //atcElement.hidden = event.type == 'mouseenter'  ? true : false;
    eachOptionBundleAndCase(atcElement, priceElement, newPrice, variant_title, event);
  }
  // future - refactor out
  if (variant_title.toLowerCase().indexOf('sample') > -1) {
    sampleOptionBundleAndCase(atcElement,event);
  }
}

/* 2024-03-14 Paul N., Pricing models - Add templates and logic for sleeve-and-case, instead of multiple-case */
/* light refactor to abstract pricing model for case-option with other purchasable options to a single function */
function otherOptionAndCase (atcElement, priceElement, newPrice, variant_title, event) {
  // if ( typeof(atcElement.dataset.originalText) === 'undefined' ) { atcElement.dataset.originalText = atcElement.innerText;}
  if ( typeof(atcElement.dataset.variantText) === 'undefined' ) { atcElement.dataset.variantText = atcElement.innerText;}

  //TODO BUG, select Case-option then hover bundle-option the AtC stays hidden and doesn't come back
 /* if (event.type == 'mouseenter' && atcElement.disabled ) {
    atcElement.dataset.originalText = atcElement.innerText;
  }*/
  if ( variant_title.toLowerCase().indexOf('sleeve') > -1 ) {
    toggleATCText(event,atcElement, atcElement.dataset.variantText, window.languages.productFormPricingSleeveAndCase);
    if ( document.body.classList.toString().toLowerCase().indexOf('pricing-option-case') == -1 ) {
      toggleATC(event,atcElement);
    }
  }
  if (variant_title.toLowerCase().indexOf('case') > -1  ) {
    toggleATCText(event, atcElement, atcElement.dataset.variantText, window.languages.productFormPricingSleeveAndCase);
    if ( document.body.classList.toString().toLowerCase().indexOf('pricing-option-sleeve') == -1 ) {
      toggleATC(event, atcElement);
    }
  }

  if (variant_title.toLowerCase().indexOf('each') > -1 ) {
    eachOptionCaseAndOtherOption(atcElement, priceElement, newPrice, variant_title, event, 'pricing-option-sleeve', window.languages.productFormPricingSleeveAndCase, atcElement.dataset.originalText);
  }
  // future - refactor out
  if (variant_title.toLowerCase().indexOf('sample') > -1) {
    sampleOptionCaseAndOtherOption(atcElement,event, 'pricing-option-sleeve', window.languages.productFormPricingSleeveAndCase, atcElement.dataset.originalText);
  }

  if (event.type == 'mouseleave' && atcElement.disabled && typeof(atcElement.dataset.originalText) !== 'undefined') {
    atcElement.removeAttribute('data-original-text');
  }
}
  //TODO: begin to abstract eachOptionBundleAndCase to accept ATC text and for ANY option, i.e. eachOptionCaseAndOtherOption()
  function eachOptionCaseAndOtherOption(atcElement, priceElement, newPrice, variant_title, event, pricingClass, oldAtcText, newAtcText){
    toggleClass( document.body, 'pricing-option-each--hover', (event.type == 'mouseenter') );
    pricingModelUpdatePrice(event,priceElement,newPrice);

    debugger
    if ( document.body.classList.toString().toLowerCase().indexOf(pricingClass) != -1 || document.body.classList.toString().toLowerCase().indexOf('pricing-option-case') != -1 ) {
      //toggleATCText(event,atcElement, oldAtcText, newAtcText);
      toggleATC(event,atcElement);
    }
    // if ( document.body.classList.toString().toLowerCase().indexOf('pricing-option-case') != -1 ) {
    //   //toggleATCText(event,atcElement, oldAtcText, newAtcText);
    //   toggleATC(event,atcElement);
    // }

  }

  //TODO: as sampleOptionCaseAndOtherOption is generice, should we abstract the sampleOptionBundleAndCase to be generic to also accept ATC text and for any option
  function sampleOptionCaseAndOtherOption(atcElement,event,pricingClass, oldAtcText, newAtcText) {
    if (typeof(pricingClass) === undefined ) { pricingClass = 'pricing-option-sleeve';}
    if (typeof(newAtcText) === undefined ) { newAtcText = window.languages.productFormPricingBundleAndCase;}
    if ( document.body.classList.toString().toLowerCase().indexOf(pricingClass) != -1 ) {
      // toggleATCText(event, atcElement, oldAtcText, window.languages.productFormPricingSleeveAndCase);
      toggleATC(event, atcElement);
    }

    /*if ( document.body.classList.toString().toLowerCase().indexOf('pricing-option-case') != -1 ) {
      // toggleATCText(event, atcElement, oldAtcText, newAtcText);
      toggleATC(event, atcElement);
    }*/
    toggleClass( document.body, 'pricing-option-sample--hover', (event.type == 'mouseenter') );
  }



function standardEachAndCase (atcElement, variant_title, event) {
  // skip events from the child <span> of the <label>
  if (event.currentTarget !== event.target) {
    return;
  }

  if (variant_title.toLowerCase().indexOf('case') > -1 && document.body.classList.toString().toLowerCase().indexOf('pricing-option-sample') != -1) {
    /* 2024-03-08 future: refactor to new toggleATC & toggleATCText functions */
    atcElement.style.display = null;
    atcElement_OldInnerText = atcElement.innerText;

    atcElement.disabled = atcElement.disabled && event.type == 'mouseenter' ? false : true ;
    atcElement.hidden = atcElement.disabled && event.type == 'mouseenter' ? false : true ;
    // atcElement.innerText = "Sold by the each and by the case.";

    atcElement.disabled = atcElement.disabled && event.type == 'mouseleave' ? true : false ;
    atcElement.hidden = atcElement.disabled && event.type == 'mouseleave' ? true : false ;
    //atcElement.innerText = atcElement_OldInnerText;
    atcElement.innerText = event.type == 'mouseenter' ? "Sold by the each & case." : atcElement_OldInnerText ;
  }

  if (variant_title.toLowerCase().indexOf('each') > -1 && document.body.classList.toString().toLowerCase().indexOf('pricing-option-sample') != -1 ) {
    /* 2024-03-08 future: refactor to new toggleATC & toggleATCText functions */
    atcElement.style.display = null;
    atcElement_OldInnerText = atcElement.innerText;

    atcElement.disabled = atcElement.disabled && event.type == 'mouseenter' ? false : true ;
    atcElement.hidden = atcElement.disabled && event.type == 'mouseenter' ? false : true ;
    //atcElement.innerText = "Sold by the each and by the case.";

    atcElement.disabled = atcElement.disabled && event.type == 'mouseleave' ? true : false ;
    atcElement.hidden = atcElement.disabled && event.type == 'mouseleave' ? true : false ;
    // atcElement.innerText = atcElement_OldInnerText;
    atcElement.innerText = event.type == 'mouseenter' ? "Sold by the each & case." : atcElement_OldInnerText ;
  }

  /* 2024-03-08 future: refactor to new sampleClass function */
  if (variant_title.toLowerCase().indexOf('sample') > -1 ) {
    /* 2023-11-18 - Standard-each-and-case template, Please Hide “Price” and “Stock:” from view when the Sample variant is moused-over or selected */
    atcElement.hidden = event.type == 'mouseenter'  ? true : false;
    if (event.type == 'mouseenter' ) {
      document.body.classList.add('pricing-option-sample--hover');
    } else {
      document.body.classList.remove('pricing-option-sample--hover');
    }
    //atcElement_OldInnerText = atcElement.innerText;
  }
}


/* get forms swatch labels for options. using "swatch" to match theme verbiage. */
  blockSwatchElements = document.querySelectorAll('[action="/cart/add"] .block-swatch__item');
    /* TODO blockSwatchAtcElement etc should probably be moved into the event function or made into GET functions */
    blockSwatchAtcElement = blockSwatchElements[0].form.querySelector('button[type="submit"]');

  blockSwatchElements.forEach(swatch => {
    // to get labels associated input: label.control . to get labels associated label checked value: label.control.checked
    // swatch.form.querySelector('button[type="submit"]');
      ['mouseenter', 'mouseleave'].forEach(function(eventType) {
        //swatch.addEventListener(e, () => ( standardCaseOnly(blockSwatchAtcElement, event.target.title,event), standardEachAndCase(blockSwatchAtcElement, event.target.title,event) ) );
        swatch.addEventListener(eventType, (event) => {
            if (event.currentTarget == event.target && event.currentTarget.control.checked == false) {

              /* 2024-03-08 Paul N., Pricing models - Add templates and logic for bundle-and-case */
              if (document.body.classList.toString().toLowerCase().indexOf('bundle-and-case') != -1) {
                priceElement = swatch.form.querySelector('.product-form__info-item--price .price');
                dataPriceEach = swatch.form.querySelector('[id^="product-select-"] [data-price-each]').dataset.priceEach;
                bundleAndCase(blockSwatchAtcElement, priceElement, dataPriceEach, event.currentTarget.title,event);
              }

              /* 2024-03-08 Paul N., Pricing models - add sleeve-and-case option logic instead of multiple-case option logic */
              if (document.body.classList.toString().toLowerCase().indexOf('sleeve-and-case') != -1) {
                priceElement = swatch.form.querySelector('.product-form__info-item--price .price');
                dataPriceEach = swatch.form.querySelector('[id^="product-select-"] [data-price-each]').dataset.priceEach;
                otherOptionAndCase(blockSwatchAtcElement, priceElement, dataPriceEach, event.currentTarget.title, event);
              }

              if (
                  document.body.classList.toString().toLowerCase().indexOf('standard-case-only') != -1
                  || document.body.classList.toString().toLowerCase().indexOf('-case-only') != -1
                ) {
                /* TODO change price when hovering each on standard-case-only template */
                /* TODO span.price element has a .visually-hidden span inside it make sure to not wipe it out */
                /* 2023-12-05 Paul N., Pricing models SOC & SEC - render price data in master selector for the "Each" option to dynamically insert when hovering options */
                priceElement = swatch.form.querySelector('.product-form__info-item--price .price');
                dataPriceEach = swatch.form.querySelector('[id^="product-select-"] [data-price-each]').dataset.priceEach;
                standardCaseOnly(blockSwatchAtcElement, priceElement, dataPriceEach, event.currentTarget.title,event);
              }

              if (
                document.body.classList.toString().toLowerCase().indexOf('standard-each-and-case') != -1
                || document.body.classList.toString().toLowerCase().indexOf('-each-and-case') != -1
              ) {
                standardEachAndCase(blockSwatchAtcElement, event.currentTarget.title,event);
              }

            }
          });
      });
  });

document.addEventListener('variant:changed', function(event) {
  //TODO check the added sleeve classes and remove sleeve hover classes?
  /*  2024-03-21 Paul N. add sleeve-and-case option logic instead of multiple-case option logic */
  var addToCartButtonElement = event.target.querySelector('.pricing-option .product-form__add-button, .bundle-and-case .product-form__add-button, .sleeve-and-case .product-form__add-button, .standard-case-only .product-form__add-button, .standard-each-and-case .product-form__add-button');
  /* 2024-05-15 Paul N. partial refactor - let AtC selector be defined by template in a data attribute on the <body> so it doesn't have be manually updated in this file everytime a new template is made: */
   if ( !addToCartButtonElement && typeof(document.body.dataset.selectorAddToCartButtonElement) !== 'undefined' ) {
    addToCartButtonElement = event.target.querySelector(document.body.dataset.selectorAddToCartButtonElement);
  }
  /* 2024-06-27 Paul N. add early return if no addToCartButtonElement */
  if(!addToCartButtonElement) { return ; }
 // 2023-11-22 get rid of hover classes when variant changes to prevent bad states
  document.body.classList.remove('pricing-option-bundle--hover','pricing-option-sleeve--hover','pricing-option-case--hover','pricing-option-each--hover','pricing-option-sample--hover');

  var variant = event.detail.variant;
  // var bodyClassList = document.body.classList
  console.log(variant);

  if ( addToCartButtonElement ) { addToCartButtonElement.dataset.variantText = addToCartButtonElement.innerText; }

  /* add CSS classes to body based on selection option type */
  if (variant.title.toLowerCase().indexOf('bundle') > -1 || ( typeof variant != 'undefined' && !variant.available )) {
    addToCartButtonElement.style.display = null;
    addToCartButtonElement.hidden = false;
    document.body.classList.add('pricing-option-bundle');
  } else {
    document.body.classList.remove('pricing-option-bundle');
  }
  /*  2024-03-21 Paul N. add sleeve-and-case option logic instead of multiple-case option logic */
  if (variant.title.toLowerCase().indexOf('sleeve') > -1 || ( typeof variant != 'undefined' && !variant.available )) {
    addToCartButtonElement.style.display = null;
    addToCartButtonElement.hidden = false;
    document.body.classList.add('pricing-option-sleeve');
  } else {
    document.body.classList.remove('pricing-option-sleeve');
  }

  if (variant.title.toLowerCase().indexOf('case') > -1 || ( typeof variant != 'undefined' && !variant.available )) {
    addToCartButtonElement.style.display = null;
    document.body.classList.add('pricing-option-case');

    document.body.classList.remove('pricing-option-each');/*TODO test if this remove is needed */
  } else {
    document.body.classList.remove('pricing-option-case');
  }

  if (variant.title.toLowerCase().indexOf('sample') > -1) {
    // sample
    document.body.classList.remove('disable-product-sample-button');
  } else {
    // other variants
    document.body.classList.add('disable-product-sample-button');
  }
  /* END add CSS classes to body based on selection option type */


  /* 2023-01-22 Paul N. add logic or each/case pricing-option template logic, and sample CSS class flag */
  if (variant.title.toLowerCase().indexOf('each') > -1 ) {
    document.body.classList.add('pricing-option-each');

    if (typeof(addToCartButtonElement) != 'undefined' && addToCartButtonElement != null) {
      addToCartButtonElement.disabled = true;
      addToCartButtonElement.innerHTML = "Sold by the case only.";
      if (document.body.classList.toString().toLowerCase().indexOf('bundle-and-case') != -1 ) {
        addToCartButtonElement.innerHTML = window.languages.productFormPricingBundleAndCase;
      }
      if (document.body.classList.toString().toLowerCase().indexOf('sleeve-and-case') != -1 ) {
        addToCartButtonElement.innerHTML = window.languages.productFormPricingSleeveAndCase;
      }
      if (
        document.body.classList.toString().toLowerCase().indexOf('standard-each-and-case') != -1
        || document.body.classList.toString().toLowerCase().indexOf('-each-and-case') != -1
      ) {
        addToCartButtonElement.disabled = false;
        addToCartButtonElement.hidden = false;
        addToCartButtonElement.innerHTML = window.languages.productFormAddToCart;
      }
    }

  } else {
    document.body.classList.remove('pricing-option-each');
  }

  if (variant.title.toLowerCase().indexOf('sample') > -1 ) {
    document.body.classList.add('pricing-option-sample');

      if ( typeof(addToCartButtonElement) != 'undefined' && addToCartButtonElement != null ) {
        addToCartButtonElement.disabled = true;
        addToCartButtonElement.innerHTML = "Sold by the case only.";
        if (document.body.classList.toString().toLowerCase().indexOf('bundle-and-case') != -1 ) {
          addToCartButtonElement.innerHTML = window.languages.productFormPricingBundleAndCase;
        }
        if (document.body.classList.toString().toLowerCase().indexOf('sleeve-and-case') != -1 ) {
          addToCartButtonElement.innerHTML = window.languages.productFormPricingSleeveAndCase;
        }
        if (document.body.classList.toString().toLowerCase().indexOf('standard-case-only') != -1 || document.body.classList.toString().toLowerCase().indexOf('standard-each-and-case') != -1 ) {

        }
      }
  } else {
    document.body.classList.remove('pricing-option-sample');
  }

    // TODO debug to see if product is on variant object and has the template name!?!!
    //standardCaseOnly(addToCartButtonElement, variant.title);
    //standardEachAndCase(addToCartButtonElement, variant.title);

});

/* used by pricing-options in product-buy-buttons.liquid */
function toggleClass(element,cssClass,enable) {
  /*
    toggleClass replaces code like the following but with an override "enable" flag for explicit behavior:
    event.type == 'mouseenter'  ? document.body.classList.add('pricing-option-each--hover') : document.body.classList.remove('pricing-option-each--hover') ;
    event.type == 'mouseenter'  ? toggleClass( document.body, 'pricing-option-each--hover', true ) : toggleClass( document.body, 'pricing-option-each--hover', false ) ;
  */
  if (typeof(enable) === 'undefined') {
    element.classList.toggle(cssClass);
  } else {
    enable ? element.classList.add(cssClass) : element.classList.remove(cssClass);
  }
}
